export default
{
  'messages': {
    'req_in_que': 'Please wait for call-in signal.',
    'please_enter': 'Please enter',
    'doing': 'Being processed',
  },
}
